import { cmtsEnv } from "../../config/env.config.js";

export const cmtsPwaRuntimeVersion = {
  appVersion: cmtsEnv.CMTS_CLIENT_APP_VERSION || "cmts-frontend-1.2.1",
  serviceWorkerVersion: "cmts-sw-v20260618-1",
  assetCacheName: "cmts-assets-v20260618-1",
  runtimeCacheName: "cmts-runtime-v20260618-1",
  apiCacheName: "cmts-api-v20260618-1",
  indexedDbMigrationVersion: 2026061801,
} as const;

export const cmtsAppOwnedCachePrefixes = [
  "cmts-",
  "swot-cmts-",
  "swotdiginxt-cmts-",
  "vite-cmts-",
  "workbox-cmts-",
  "cmts-enterprise-shell",
] as const;

export const cmtsCurrentCacheAllowList = [
  cmtsPwaRuntimeVersion.assetCacheName,
  cmtsPwaRuntimeVersion.runtimeCacheName,
] as const;

export function isCmtsAppOwnedCacheName(name: string): boolean {
  return cmtsAppOwnedCachePrefixes.some((prefix) => name.startsWith(prefix));
}
